import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import SectionHeader from '@/components/base/SectionHeader';

const byId = (id: string) => {
  const found = comics.find((c) => c.id === id);
  return found as (typeof comics)[number];
};

const picks = ['jsrj', 'myyt', 'xyt'].map(byId);

export default function EditorPicks() {
  return (
    <section className="bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          title="编辑精选"
          subtitle="编辑部力荐的高分佳作，不容错过"
          moreTo="/category"
        />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {picks.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className={`group flex flex-col gap-4 rounded-2xl bg-background-50 p-5 transition-colors hover:bg-background-100 sm:flex-row lg:flex-col xl:flex-row ${
                index === 1 ? 'lg:bg-accent-100/60' : ''
              }`}
            >
              <div className="w-full shrink-0 overflow-hidden rounded-xl sm:w-36 lg:w-full xl:w-36">
                <div className="aspect-[3/4] w-full">
                  <img
                    src={comic.cover}
                    alt={`《${comic.title}》漫画封面`}
                    title={`《${comic.title}》漫画在线免费阅读`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="flex flex-1 flex-col">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-primary-100 px-2 py-0.5 text-xs text-primary-700">
                    编辑推荐
                  </span>
                  <span className="flex items-center gap-0.5 text-xs text-accent-600">
                    <i className="ri-star-fill"></i>
                    {comic.rating} 分
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-lg text-foreground-950">
                  《{comic.title}》
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-6 text-foreground-600">
                  {comic.description}
                </p>
                <div className="mt-auto pt-4">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                    立即开读
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}